import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment-timezone';
import App from './App';
import './styles/index.scss';
import * as serviceWorker from './serviceWorker';
import './services/axios/interceptors';

moment.tz.setDefault('Africa/Abidjan'); // To set timezone to UTC+0 throughout in the project

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
